import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipeFoto'
})
export class PipeFotoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value || value =='')return 'https://www.diviprev.mg.gov.br/fotosServidores/padrao.png';
    return 'https://www.diviprev.mg.gov.br/fotosServidores/'+value;
  }

}
